import type { FunctionComponent } from 'react'
import React, { useContext, useState } from 'react'

import { RadioGroupPage } from '../../../../shared/pages/RadioGroupPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { AgeFlow, OutcomeFlow, ReportedToOmbudsmanFlow } from '../../pageFlowData'
import { outcomeData } from './data'

export const Outcome: FunctionComponent = () => {
  const [isInputValid, setInputValid] = useState(true)
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    victim: { outcome },
  } = state
  const [radioSelected, setRadioSelected] = useState(outcome)

  const handleChange = (id: string) => {
    setRadioSelected(id)
  }

  const handleStepChoice = () => {
    if (radioSelected === 'waiting' || radioSelected === 'all-money-back') {
      return { progress: AgeFlow.PROGRESS_VALUE, step: AgeFlow.STEP }
    }

    return { progress: ReportedToOmbudsmanFlow.PROGRESS_VALUE, step: ReportedToOmbudsmanFlow.STEP }
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${OutcomeFlow.VIEW_NAME} | ${radioSelected}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = () => {
    const { progress, step } = handleStepChoice()

    dispatch({ type: 'UPDATE_OUTCOME', data: radioSelected })
    dispatch({ type: 'UPDATE_STEP', data: step })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: progress })
  }

  const handleSubmit = () => {
    if (radioSelected) {
      setInputValid(true)
      handleTracking()
      handleDispatch()
    }
    setInputValid(false)
  }

  const { buttons, title, imgObj } = outcomeData

  return (
    <RadioGroupPage
      buttonText="Next"
      buttons={buttons}
      fullWidthContainer
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isInputValid={isInputValid}
      stateValue={radioSelected}
      title={title}
    />
  )
}
